import { render, staticRenderFns } from "./WonderYjjRateIndustry.vue?vue&type=template&id=1930c32c"
import script from "./WonderYjjRateIndustry.vue?vue&type=script&lang=js"
export * from "./WonderYjjRateIndustry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports